import React from 'react';
import Wrapper from './DotsStyles';

export interface Props {
  dots: React.ReactNode;
}

const Dots = ({ dots }: Props) => <Wrapper>{dots}</Wrapper>;

// Function to be used with react-slicker appendDots method.
export function addDots(dots: React.ReactNode) {
  return <Dots dots={dots} />;
}

export default Dots;
